// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, render } from '@plesk/ui-library';
import App from './App';

const Plesk = {
    data: {},

    run(config, data) {
        this.data = data;
        render(
            <App config={config} />,
            document.getElementById('main')
        );
    },

    getData(url) {
        return new Promise(resolve => {
            if (this.data[url]) {
                resolve(this.data[url]);
                delete this.data[url];
                return;
            }

            new Ajax.Request(url, {
                method: 'get',
                onComplete: transport => {
                    resolve(transport.responseText.evalJSON());
                },
            });
        });
    },
};

export default Plesk;



// WEBPACK FOOTER //
// ./plesk/Plesk.js